import React from 'react';
import AdminLayout from '../../../components/Layout/AdminLayout';
import Currency from './Currency';
import messages from '../../../locale/jsonMessages';

export default async function action({ store, intl }) {

  const title = intl?.formatMessage(messages.manageCurrency);

  // From Redux Store
  let isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;

  let isSuperAdmin = store.getState().runtime.isSuperAdmin

  if (!isAdminAuthenticated || !isSuperAdmin) {
    return { redirect: '/siteadmin/login' };
  }

  return {
    title,
    component: <AdminLayout><Currency title={title} /></AdminLayout>,
  };
};
